import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section3 = () => {
  const { t } = useTranslation();

  return (
    <div className=" mt-28 mb-28 pt-28  border-t-2 grid grid-cols-10">
      <div className="col-start-2 col-span-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          exit="exit"
          variants={containerVariants}
          className="h-[50vh]"
        >
          <motion.img
            initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants}
            src="/images/about/3.jpg"
            className="w-full h-full object-cover object-center"
          />
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          exit="exit"
          variants={containerVariants}
          className="grid grid-cols-1 md:grid-cols-2 mt-28 space-y-14 md:space-y-0"
        >
          <div className="flex flex-col">
            <motion.h1
              variants={itemVariants}
              className=" text-65  text-customYellow mb-3"
            >
              {t("about.section3.mission.title")}
            </motion.h1>
            <motion.p
              variants={itemVariants}
              className="w-full md:w-2/3 text-20 font-light text-customGray"
            >
              {t("about.section3.mission.text")}
            </motion.p>
          </div>

          <div className="flex flex-col">
            <motion.h1
              variants={itemVariants}
              className=" text-65  text-customYellow mb-3"
            >
              {t("about.section3.vision.title")}
            </motion.h1>
            <motion.p
              variants={itemVariants}
              className="w-full md:w-2/3 text-20 font-light text-customGray"
            >
              {t("about.section3.vision.text")}
            </motion.p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Section3;
